/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type ListingDetailResponseDtoFurnishingType = typeof ListingDetailResponseDtoFurnishingType[keyof typeof ListingDetailResponseDtoFurnishingType] | null;


export const ListingDetailResponseDtoFurnishingType = {
  PARTIAL: 'PARTIAL',
  BY_AGREEMENT: 'BY_AGREEMENT',
  UNFURNISHED: 'UNFURNISHED',
  FULL: 'FULL',
} as const;
